import { useState } from 'react';
import { api } from '../lib/api';
import { EnvelopeIcon, SparklesIcon } from '@heroicons/react/24/outline';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setMessage('');

    try {
      const response = await api.requestMagicLink(email);
      setMessage(response.message);
      setEmail('');
    } catch (err: any) {
      setError(err.response?.data?.error || 'Failed to send magic link');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-2xl shadow-xl shadow-charcoal-500/5 border border-charcoal-100/60 overflow-hidden">
      {/* Decorative gradient strip at top */}
      <div className="h-1 bg-gradient-to-r from-copper-400 via-sage-400 to-teal-400" />

      <div className="p-8">
        <h2 className="text-2xl font-bold text-charcoal-500 mb-1">Sign in to your account</h2>
        <p className="text-sm text-charcoal-300 mb-6">Enter your email and we'll send you a magic link.</p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-charcoal-400 mb-2">
              Email address
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <EnvelopeIcon className="h-5 w-5 text-charcoal-250" />
              </div>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input pl-10"
                placeholder="you@example.com"
              />
            </div>
          </div>

          {message && (
            <div className="rounded-xl bg-sage-50 p-4 border border-sage-200 flex items-start gap-3">
              <SparklesIcon className="h-5 w-5 text-sage-500 mt-0.5 flex-shrink-0" />
              <p className="text-sm text-sage-700">{message}</p>
            </div>
          )}

          {error && (
            <div className="rounded-xl bg-red-50 p-4 border border-red-200">
              <p className="text-sm text-red-800">{error}</p>
            </div>
          )}

          <button
            type="submit"
            disabled={isLoading}
            className="btn btn-primary w-full disabled:opacity-50 disabled:cursor-not-allowed relative overflow-hidden group"
          >
            <span className="relative z-10">{isLoading ? 'Sending...' : 'Send magic link'}</span>
          </button>
        </form>

        <div className="flex items-center gap-3 mt-6">
          <div className="flex-1 h-px bg-charcoal-100" />
          <p className="text-xs text-charcoal-250">No password needed</p>
          <div className="flex-1 h-px bg-charcoal-100" />
        </div>
      </div>
    </div>
  );
}
